import type { ReactNode } from 'react';
import { Button, Cluster, GoogleIcon, Panel, TelegramIcon, Typography, VkIcon } from '@src/components';
import './SocialLinkCard.css';

export type SocialLinkKind = 'google' | 'telegram' | 'vk';

const ICONS: Record<SocialLinkKind, ReactNode> = {
  google: <GoogleIcon />,
  telegram: <TelegramIcon />,
  vk: <VkIcon />,
};

export interface SocialLinkCardProps {
  kind: SocialLinkKind;
  title: string;
  hint: string;
  actionLabel: string;
  onAction: () => void;
  testId?: string;
}

/** One linked social account row in account settings. */
export function SocialLinkCard({
  kind,
  title,
  hint,
  actionLabel,
  onAction,
  testId,
}: SocialLinkCardProps) {
  return (
    <Panel padding="medium" wide className="social-link-card" testId={testId}>
      <div className="social-link-card__main">
        <Cluster align="center" gap={4} wrap={false} className="social-link-card__lead">
          <span className={`social-link-card__icon social-link-card__icon--${kind}`} aria-hidden="true">
            {ICONS[kind]}
          </span>
          <div className="social-link-card__copy">
            <Typography as="p" role="label/control">
              {title}
            </Typography>
            <Typography as="p" role="meta/helper">
              {hint}
            </Typography>
          </div>
        </Cluster>
        <div className="social-link-card__action">
          <Button variant="secondary" size="small" onClick={onAction} testId={`${testId}-action`}>
            {actionLabel}
          </Button>
        </div>
      </div>
    </Panel>
  );
}
